import React from "react";
import type { DialogProps } from "../shared/dialog/Dialog";

interface DialogContextProps {
  dialog: DialogProps | null;
  showDialog: (dialogProps: DialogProps) => void;
  hideDialog: () => void;
}

const DialogContext = React.createContext<DialogContextProps | null>(null);

export const DialogProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [dialog, setDialog] = React.useState<DialogProps | null>(null);

  const showDialog = (dialogProps: DialogProps) => {
    setDialog(dialogProps);
  };

  const hideDialog = () => {
    setDialog(null);
  };

  return <DialogContext.Provider value={{ dialog, showDialog, hideDialog }}>{children}</DialogContext.Provider>;
};

export const useDialog = () => {
  const context = React.useContext(DialogContext);
  if (context === null) {
    throw new Error("useDialog must be used within a DialogProvider");
  }
  return context;
};
